import {LitElement, css, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { AuthService } from '../../../src/services/auth-service';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import "@maersk-global/mds-components-core/mc-modal";

export class VoyageLoginOverlay extends LitElement {
    static get properties() {
        return {
            checking: {type: Boolean},
            relogin : {type: Boolean}
        }
    }

    static get styles() {
        return [
            css`
            :host {
                position: fixed;
                display: flex;
                top:0;
                left:0;
                width: 100vw;
                height: 100vh;
                z-index: 1000;
                align-items: center;
                justify-content: center;
            }

            .dialog {
                background-color: var(--neutrals-grey-10, white);
                padding: 0;
                width: 50%;
                min-width: 500px;
            }




            .paragraph {
                color: var(--neutrals-grey-03, black);
                font-family: var(--component-paragraph-ff, 'serif');
                font-size: 14px;
                line-height: normal;
                font-weight: var(--component-paragraph-weight, normal);
                text-align: center;
                margin: 30px 0 0 0;
            }

            button {
                color: var(--neutrals-grey-10, white);
                background-color: var(--primary-blue-05, blue);
                font-size: 14px;
                line-height: normal;
                font-weight: var(--component-paragraph-weight, normal);
                height: 56px;
                width: 166px;
                margin: 16px;
                opacity: 0;
                transition: opacity 300ms linear;
                border: none;
            }

            button:not([disabled]) {
                cursor: pointer;
                opacity: 1;
            }
            
            .container {
                overflow: hidden;
            }

            .container p{
                font-family: "Maersk Text";
                font-weight: 400px;
                font-size: 16px;
                line-height: 24px;
                color: #545454;
                margin-top: 16px;
            }

            .container svg{
                margin-top: 16px;
            }

            .heading{
                font-family: 'MaerskHeadline';
                line-height: 24px;
                font-size: 20px;
                font-weight: 400;
            }

            #login {
                margin: 8px -8px 8px 0;
            }

            .container p{
                font-family: "Maersk Text";
                font-weight: 400px;
                font-size: 16px;
                line-height: 24px;
                color: #545454;
                margin-top: 16px;
            }

            .container svg{
                margin-top: 16px;
            }

            .heading{
                font-family: 'MaerskHeadline';
                line-height: 24px;
                font-size: 20px;
                font-weight: 400;
            }

            #login {
                margin: 8px 0;
            }

            `
        ];
    }

    constructor() {
        super();

        this.checking = true;

        this.notChecking = this.notChecking.bind(this);
    }

    render() {
        const title = this.checking ? "Authorizing..." : "Login"
        return html`
        <div class="dialog">
           <mc-modal
                dimension="small"
                width="440px"
                height="296px"
                ?open=${true}
                hiddenclose
                backdropcloseactiondisabled
                escapecloseactiondisabled
                entercloseactiondisabled
                >
                <div class="container">
                     <span slot="heading" class="heading">${title}</span>
                     <p class="description"> Please login to start using Fleet Voyage.</p>
                     <p>${SvgIcons.vesselLogin}</p>
                </div>
                 <mc-button  id="login" slot="primaryAction" appearance="primary" variant="filled" ?disabled=${this.checking} @click=${this.login} >${this.relogin?"Re-login":"Login"}</mc-button>
            </mc-modal>
        </div>     
        `;
    }

    login() {
        AuthService.doAuth();
    }

    notChecking() {
        this.checking = false;
    }

    connectedCallback() {
        super.connectedCallback();

        AuthService.addEventListener('login-required', this.notChecking);
        if (!AuthService.loginPending) {
            this.checking = false;
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        AuthService.removeEventListener('login-required', this.notChecking);
    }
};

customElements.define('voyage-login-overlay', VoyageLoginOverlay);
